import { WppTooltip } from '@wppopen/components-library-react'
import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'

import styles from './TruncatedText.module.scss'

interface Props {
  text: string | undefined
  className?: string
  maxWidth?: string
  wrapperMaxWidth?: string
}

const TruncatedText = ({ text, className, maxWidth, wrapperMaxWidth }: Props) => {
  const textRef = useRef<HTMLDivElement | null>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const element = textRef.current
    if (element) {
      setIsTruncated(element?.scrollWidth > element?.clientWidth)
    }
  }, [text])

  if (!text) return null

  return (
    <div className={clsx(className, styles.textTruncateWrapper)} style={{ maxWidth: wrapperMaxWidth || maxWidth }}>
      {isTruncated ? (
        <WppTooltip config={{ allowHTML: true }}>
          <div ref={textRef} className={clsx(styles.textTruncate, styles.textPreview)} style={{ maxWidth: maxWidth }}>
            {text}
          </div>

          <div slot="tooltip-content" className={styles.tooltipContent}>
            {text}
          </div>
        </WppTooltip>
      ) : (
        <div ref={textRef} className={styles.textTruncate}>
          {text}
        </div>
      )}
    </div>
  )
}

export default TruncatedText
